import { baseApi } from './base-api'
import {getPagedResponse, PagedResponse} from "../../../utils/helpers";
import {buildEntityTags, buildPagedResponseTags, invalidateTags} from "../../../utils/api-utils";
import {FallOut} from "../../data/entities/fallOut";

export const fallOutApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getFallOuts: build.query<PagedResponse<FallOut>, Record<string, any>>({
      query: (params) => ({
        url: `fallOut/getFallOuts`,
        params: params 
      }),
      transformResponse: getPagedResponse,
      providesTags: (result) => buildPagedResponseTags(result, 'FallOut')
    }),
    getFallOutList: build.query<PagedResponse<FallOut>, Record<string, any>>({
      query: (params) => ({
        url: `fallOut/getFallOutList`,
        params: params
      }),
      transformResponse: getPagedResponse,
      providesTags: (result) => buildPagedResponseTags(result, 'FallOut')
    }),
    getFallOut: build.query<FallOut, string>({
          query: (id) => ({
            url: `fallOut/getfallout/${id}`,
          }),
          providesTags: (result) => buildEntityTags(result, 'FallOut')
        }),
    getAllFallOuts: build.query<FallOut[], void>({
      query: () => {

        return {
          url: `fallOut/getAllFallOuts`
        }
      },
      providesTags: (result) => result
        ? [
            ...result.map((item) => ({type: 'FallOut' as const, id: item.id})),
            {type: 'FallOut' as const, id: 'LIST'}
          ]
        : [{type: 'FallOut' as const, id: 'LIST'}],
    }),
    
    createFallOut: build.mutation<any, FallOut>({
      query: (body) => ({
        url: 'fallOut/addfallout',
        method: 'post',
        body: body
      }),
      invalidatesTags: () => invalidateTags('LIST', 'FallOut'),
    }),
    updateFallOut: build.mutation<any, FallOut>({
      query: (body) => ({
        url: `fallOut/updatefallout`,
        method: 'put',
        body: body
      }),
      invalidatesTags: (_result, _error, body) => [
        ...invalidateTags(body?.id, 'FallOut'),
        ...invalidateTags('LIST', 'FallOut')
      ],
    }),
    deleteFallOut: build.mutation<any, string>({
      query: (userId) => ({
        url: `fallOut/deletefallout/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [
        ...invalidateTags(id, 'FallOut'),
        ...invalidateTags('LIST', 'FallOut')
      ],
    }),
  }),
  overrideExisting: true,
})

export const { 
  useLazyGetFallOutQuery,
  useLazyGetFallOutsQuery,
  useLazyGetFallOutListQuery,
  useCreateFallOutMutation, 
  useUpdateFallOutMutation,
  useDeleteFallOutMutation,
  useGetAllFallOutsQuery
} = fallOutApi
